var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._g(_vm._b({}, 'v-card', _vm.$attrs, false), {
    click: _vm.click
  }), [_vm.src ? _c('v-img', _vm._b({
    attrs: {
      "src": _vm.src
    }
  }, 'v-img', Object.assign({}, _vm.$attrs), false)) : _c('v-sheet', {
    attrs: {
      "color": "grey lighten-3"
    }
  }, [_c('v-responsive', {
    staticClass: "d-flex text-center align-center",
    attrs: {
      "aspect-ratio": 1 / 1
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("mdi-image")])], 1)], 1), _c('v-file-input', _vm._b({
    ref: "fileInput",
    staticClass: "d-none",
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.file,
      callback: function ($$v) {
        _vm.file = $$v;
      },
      expression: "file"
    }
  }, 'v-file-input', _vm.$attrs, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }